import React from "react"
import { css } from "styled-components"
import QuoteMark from "../../components/shared/svg/quote-mark"
import Divider from "../atoms/divider"
import Text from "../atoms/text"
import VariantContainer from "../atoms/variant-container"
import { BT } from "../styles/blog-typography"

interface IBlockQuoteProps {
  children?: React.ReactNode
}

/**
 * Wraps the children in a blockquote with a divider.
 */
const BlockQuote = ({ children }: IBlockQuoteProps) => {
  return (
    <>
      <Divider />
      <VariantContainer
        variants={[
          css`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 32px 0;
            svg {
              max-width: 30px;
            }
          `,
          css`
            flex-direction: row;
            align-items: flex-start;
            padding: 48px 0;
            svg {
              max-width: 40px;
              margin-right: 24px;
            }
          `,
        ]}
      >
        {/* var(--burnt-orange) === #bf4320 */}
        <QuoteMark colour="#bf4320" />
        {children && (
          <Text
            variants={[
              css`
                margin-top: 16px;
                ${BT.sm.h2`400`}
                text-align: center;
              `,
              css`
                margin: 0;
                ${BT.md.h1`300`}
                text-align: left;
              `,
            ]}
          >
            {children}
          </Text>
        )}
      </VariantContainer>
      <Divider />
    </>
  )
}

export default BlockQuote
